module.exports = __webpack_public_path__ + "static/media/FSSC 22000.176ec684.png";